import { css } from "@compiled/react";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { useLoggedOut } from "@/components/user-context";
import { wacToken } from "@/libraries/design/foundations";
import StickyContainer from "@/patterns/sticky-container/sticky-container";

import { ParentScrollTracking } from "../../../../../../utils/scroll-tracking";
import JiraSoftwareNav from "../../../sections/nav-bar/software-jira-navbar";

import { AiRefreshSection } from "./ai-refresh-section";
import { JiraSoftwarePageBannerAlert } from "./sections/banner-alert";
import { GartnerSection } from "./sections/gartner-section";
import {
    NoJiraHeroSection,
    JswCollaborateSection,
    BuildAndSupportDoubleFeatureSection,
    JswDoubleFeatureSection,
    IntegrationsSection,
    TestimonialSection,
    ClosingBanner
} from "./sections/productionized";
import { Footer } from "./sections/productionized/footer";
import { LoggedOutHeroSection } from "./sections/productionized/logged-out-hero-section";

export const LoggedOutOrNoJiraProductTourOverview = () => {
    const isLoggedOut = useLoggedOut();

    let heroSection = <NoJiraHeroSection />;

    if (isLoggedOut) {
        heroSection = <LoggedOutHeroSection />;
    }

    return (
        <UFOSegment name="logged-out-no-jira-product-tour">
            <JiraSoftwarePageBannerAlert />
            <StickyContainer>
                <JiraSoftwareNav />
            </StickyContainer>
            <main
                css={sectionContainerStyles}
                data-testid="loggedOutNoJira"
                id="content"
            >
                <ParentScrollTracking
                    scrollTrackingEnabled={true}
                    pageId="Jira"
                >
                    {heroSection}
                    <GartnerSection />
                    <JswCollaborateSection />
                    <AiRefreshSection />
                    <BuildAndSupportDoubleFeatureSection />
                    <JswDoubleFeatureSection />
                    <IntegrationsSection />
                    <div css={backgroundStyles}>
                        <TestimonialSection />
                        <ClosingBanner />
                    </div>
                    <Footer />
                </ParentScrollTracking>
            </main>
        </UFOSegment>
    );
};

const sectionContainerStyles = css({
    display: "flex",
    flexDirection: "column",
    overflow: "hidden"
});

const backgroundStyles = css({
    backgroundColor: wacToken("color.primary.blue")
});
